'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z' });

var Fullscreen = function Fullscreen(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Fullscreen = (0, _pure2.default)(Fullscreen);
Fullscreen.muiName = 'SvgIcon';

exports.default = Fullscreen;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Fullscreen.js
// module id = 2453
// module chunks = 0